module.exports = __webpack_public_path__ + "img/banner-2.14676090.png";